function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction;
module.exports["default"] = module.exports, module.exports.__esModule = true;


// WEBPACK FOOTER //
// ./node_modules/@babel/runtime/helpers/isNativeFunction.js